import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JaldeeReportService } from 'src/app/services/jaldee-report.service';
import { ManualSubscriptionService } from 'src/app/services/manual-subscription.service';

@Component({
  selector: 'app-change-proform-status-dialog',
  templateUrl: './change-proform-status-dialog.component.html',
  styleUrls: ['./change-proform-status-dialog.component.css']
})
export class ChangeProformStatusDialogComponent implements OnInit {
  public changeInvoiceForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  invoiceDetails: any;
  btnDisabled = true;
  statusList: any = [
    { name: "NotSent", displayName: "Not Sent" },
    { name: "Sent", displayName: "Sent" },
    { name: "Cancelled", displayName: "Cancelled" }
  ];
  constructor(private formbuilder: UntypedFormBuilder, private matDialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any, private manualsubscriptionservice: ManualSubscriptionService,) { }

  ngOnInit() {
    this.invoiceDetails = this.data;
    console.log(this.invoiceDetails)
    this.changeInvoiceForm = this.formbuilder.group({
      invoiceChangeStatus: ''
    });
  }
  OnChangeInvoiceStatusSubmit() {
    this.manualsubscriptionservice.changeInvoiceStatus(this.invoiceDetails.uuid, this.changeInvoiceForm.value.invoiceChangeStatus)
      .subscribe(res => {
        this.api_success = 'Invoice Status Updated Successfully';
        setTimeout(() => {
          this.matDialogRef.close();
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
        });
  }
  radioChange() {
    console.log(this.changeInvoiceForm.get('invoiceChangeStatus').value);
    if ((this.changeInvoiceForm.get('invoiceChangeStatus').value) !== ' ') {
      this.btnDisabled = false;
    } else {
      this.btnDisabled = true;
    }
  }
  getDisplayName(mode: string): string {
    const modeObj = this.statusList.find(m => m.name === mode);
    return modeObj ? modeObj.displayName : mode;
  }
}
